import { createAction } from 'redux-actions'

const GET_ADDONS = createAction('GET_ADDONS')
const SET_ADDONS = createAction('SET_ADDONS')

export {
  GET_ADDONS,
  SET_ADDONS,
}
